export enum SocialActionEnum {
  SET_RESULT = "SET_RESULT",
  SET_TOKEN = "SET_TOKEN",
  SET_WALLET_ID = "SET_WALLET_ID",
  SET_TELEGRAM_SUBSCRIPTION = "SET_TELEGRAM_SUBSCRIPTION",
  SET_SLIDER_INDEX = "SET_SLIDER_INDEX",
  SET_DISABELD_TAB = "SET_DISABELD_TAB",
  SET_BALANCE = "SET_BALANCE",
  SET_ISADDRES = "SET_ISADDRES",
  SET_CLICK_BUTTON = "SET_CLICK_BUTTON",
  SET_ACCOUNT_LOCAL = "SET_ACCOUNT_LOCAL",
  SET_CLICKED_BUY = "SET_CLICKED_BUY",
  SET_BUSD_COIN = "SET_BUSD_COIN",
  SET_SWEET_PRESALAE_COIN = "SET_SWEET_PRESALAE_COIN",
  SET_PROVIDER = "SET_PROVIDER",
  SET_OPEN_BURGER_MENU = "SET_OPEN_BURGER_MENU",
  SET_USER_NFTS = "SET_USER_NFTS",
  SET_CURRENT_BLOCK = "SET_CURRENT_BLOCK",
  SET_FREEZES_BLOCK = "SET_FREEZES_BLOCK",
  SET_FREEZES_NFT_ID = "SET_FREEZES_NFT_ID",
  SET_FREEZES_NFT = "SET_FREEZES_NFT",
  SET_ACCOUNT_CONNECTED = "SET_ACCOUNT_CONNECTED",
  SET_OPEN_DRAWWER_MENU = "SET_OPEN_DRAWWER_MENU",
  SET_ACCOUNT_SWEET = "SET_ACCOUNT_SWEET",
  GET_SWEET_FREEZE_CARD_BALANCE = "GET_SWEET_FREEZE_CARD_BALANCE",
  SET_BNB_BALANCE = "SET_BNB_BALANCE",
  SET_STAKES_USERS = "SET_STAKES_USERS",
  SET_FREEZE_INFO = "SET_FREEZE_INFO",
}
export interface SocialState {
  result: number;
  token: null | string;
  wallet_id: undefined | null | string;
  isTelegramConnected: boolean;
  sliderIndex: number;
  disabledTab: boolean;
  balanceCount: any;
  isAddress: boolean;
  isConnectButtonClick: boolean;
  accountLocal: string;
  clickedBuySweet: boolean;
  busdCoin: number;
  presaleSweetCoin: number | string | null;
  provider: any;
  openBurgerMenu: boolean;
  drawwerMenu: boolean;
  userNfts: any;
  currentBlock: number | null;
  freezesBlock: Array<[]>;
  freezesNftID: Array<[]>;
  freezesNft: Array<[]>;
  connected: boolean;
  accountSweet: number | string;
  sweetFreezeCountCardBalance: number | string;
  bnbBalance: number | string;
  usersStakes: any;
  freezeInfo: any;
}
export interface Items {
  check: boolean;
  disabled: boolean;
  icon: any;
  id: number;
  linkName: string;
  name: string;
  backName: string;
  memberText: boolean;
}
export interface StepItems {
  id: number;
  img: any;
  line: Boolean;
  status: Boolean;
}
export interface ILinks {
  id: number;
  icons: any;
  name: string;
  check: boolean;
  linkName: string;
  backName: string;
  onClick: (backName: string) => void;
  isDisabled: boolean;
  account: undefined | null | string;
}

export interface IWallet {
  wallet: {
    id: number;
    icon: any;
    name: string;
    isHasAccount: boolean;
    key: string;
    memberText: boolean;
  };
  account: undefined | null | string;
}
